import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RootState } from './store';

export const themes = [
    {
        name: 'default' as const,
    },
] as const;

export type Themes = (typeof themes)[number];

export interface UIState {
    darkMode: boolean;
    theme: Themes['name'];
    compactMenu: boolean;
}

const readBoolean = (key: string, fallback: boolean) => {
    try {
        const v = localStorage.getItem(key);
        return v === null ? fallback : v === 'true';
    } catch {
        return fallback;
    }
};

const readString = (key: string, fallback: string) => {
    try {
        const v = localStorage.getItem(key);
        return v === null ? fallback : v;
    } catch {
        return fallback;
    }
};

// Single theme; color scheme concept removed.
const initialTheme = 'default' as const;

const initialState: UIState = {
    darkMode: readBoolean('darkMode', false),
    theme: initialTheme,
    compactMenu: readBoolean('compactMenu', true),
};

export const uiSlice = createSlice({
    name: 'ui',
    initialState,
    reducers: {
        setDarkMode: (state, action: PayloadAction<boolean>) => {
            state.darkMode = action.payload;
            try {
                localStorage.setItem('darkMode', String(action.payload));
            } catch {}
        },
        setTheme: (state, action: PayloadAction<Themes['name']>) => {
            state.theme = action.payload;
            try {
                localStorage.setItem('theme', action.payload);
            } catch {}
        },
        setCompactMenu: (state, action: PayloadAction<boolean>) => {
            state.compactMenu = action.payload;
            try {
                localStorage.setItem('compactMenu', String(action.payload));
            } catch {}
        },
    },
});

export const { setDarkMode, setTheme, setCompactMenu } = uiSlice.actions;

// Selectors (canonical)
export const selectDarkMode = (state: RootState) => state.ui.darkMode;
export const selectTheme = (state: RootState) => state.ui.theme;
export const selectCompactMenu = (state: RootState) => state.ui.compactMenu;

export default uiSlice.reducer;
